import React from "react";

const ColorModeContext = React.createContext({
  toggleColorMode: (_) => { },
  setColorTheme: (_) => { }
});

export default ColorModeContext;